/* eslint-disable no-self-compare */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import ReactGA from 'react-ga';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';



ReactGA.initialize('UA-8294294-40');

Number.isNaN = Number.isNaN || function (value) {
    return value !== value;
}


i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: 'en',
        debug: false,
        keySeparator: '>',
        nsSeparator: '|',

        detection: {
            order: ['querystring', 'navigator', 'htmlTag', 'path', 'subdomain'],
            caches: [],
        },

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },

        backend: {
            loadPath: `/api/localization?culture={{lng}}`,
            crossDomain: true,
        },

        react: {
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'sup'],
        }
    });



const rootElement = document.getElementById('root');
ReactDOM.render(<App />, rootElement);



// WEBPACK FOOTER //
// ./src/index.js